/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular2-masonry/src/masonry';
const styles_AngularMasonry:any[] = ([] as any[]);
export const RenderType_AngularMasonry:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AngularMasonry,data:{}});
export function View_AngularMasonry_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_AngularMasonry_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['masonry',
      '']],(null as any),(null as any),(null as any),View_AngularMasonry_0,RenderType_AngularMasonry)),
      i0.ɵdid(1,245760,(null as any),0,i1.AngularMasonry,[i0.ElementRef],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AngularMasonryNgFactory:i0.ComponentFactory<i1.AngularMasonry> = i0.ɵccf('[masonry], masonry',
    i1.AngularMasonry,View_AngularMasonry_Host_0,{options:'options',useImagesLoaded:'useImagesLoaded'},
    {layoutComplete:'layoutComplete',removeComplete:'removeComplete'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMzk3NTczMjM4NC9zcmMvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLW1hc29ucnkvc3JjL21hc29ucnkubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmMzOTc1NzMyMzg0L3NyYy9ub2RlX21vZHVsZXMvYW5ndWxhcjItbWFzb25yeS9zcmMvbWFzb25yeS50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzk3NTczMjM4NC9zcmMvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLW1hc29ucnkvc3JjL21hc29ucnkudHMuQW5ndWxhck1hc29ucnkuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzk3NTczMjM4NC9zcmMvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLW1hc29ucnkvc3JjL21hc29ucnkudHMuQW5ndWxhck1hc29ucnlfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGVudD48L25nLWNvbnRlbnQ+IiwiPGRpdiBtYXNvbnJ5PjwvZGl2PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OzJCQ0FBOzs7b0JDQUE7TUFBQTthQUFBO1VBQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src3975732384/src/src/$$_gendir/~/angular2-masonry/src/masonry.ngfactory.ts